<template>
  <div>
    <div>
      <el-button
        v-if="!value"
        type="primary"
        size="small"
        @click="handleSelectExcel"
      >
        {{ btnUpload }}
      </el-button>
      <input
        ref="input"
        style="display: none"
        type="file"
        :accept="ACCEPT.excel"
        @change="handleFileChange"
      />
      <el-tag v-if="value" closable @close="handleRemoveExcel">
        {{ value.name }}
      </el-tag>
    </div>
    <el-button
      v-if="btnTemp"
      type="success"
      size="small"
      @click="handleDownloadTemp"
    >
      {{ btnTemp }}
    </el-button>
    <el-button
      v-if="btnList"
      type="success"
      size="small"
      @click="handleDownloadList"
    >
      {{ btnList }}
    </el-button>
  </div>
</template>
<script>
import { ACCEPT } from "@/const/CommonConst.js";

export default {
  name: "YsUploadCombo",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: File,
      default: null,
    },
    btnUpload: {
      type: String,
      default: "上传",
    },
    btnTemp: {
      type: String,
      default: "下载模版",
    },
    btnList: {
      type: String,
      default: "下载当前名单",
    },
    /**
     * 下载模版方法
     */
    downloadTemp: {
      type: Function,
      default: () => {},
    },
    /**
     * 下载列表方法
     */
    downloadList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      ACCEPT,
    };
  },
  methods: {
    handleSelectExcel() {
      this.$refs.input.click();
    },
    handleFileChange(e) {
      this.$emit("change", e.target.files[0]);
      this.$refs.input.value = "";
    },
    handleRemoveExcel() {
      this.$emit("change", null);
      this.$refs.input.value = "";
    },
    handleDownloadTemp() {
      if (typeof this.downloadTemp === "function") {
        this.downloadTemp();
      }
    },
    handleDownloadList() {
      if (typeof this.downloadList === "function") {
        this.downloadList();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/YsForm/YsUploadCombo.vue